import React from "react";
import { createContext, useContext, useState } from "react"
import { RenderHeader } from "../components/structure/header";
import {API_SERVER_URL} from "../utils/config_ip_details";
import {API_SUCCESS_RESPONSE_CODE} from "../utils/config_mapping"
import { RenderRoutes,RenderMenuLeft } from "../components/structure/rendernavigation";
import { useNavigate } from "react-router-dom";
import {apiCall} from "../utils/server_utils"
import {trackError} from "../utils/error_tracker"
// import '../assets/css/bootstrap.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';
// import '../assets/css/icons.min.css'
import '../assets/css/app.min.css'
// import '../assets/css/custom.min.css'
import '../index.css'
const AuthContext = createContext();
export const AuthData = () => useContext(AuthContext);
export const AuthWrapper = () => {
     const [isLoggedIn, setIsLoggedIn] = useState(
          !!localStorage.getItem("login")
      );
     const [ user, setUser ] = useState({name: "", isAuthenticated: false})
     const navigate = useNavigate();
     const login = (userName, password) => {
       
          // Make a call to the authentication API to check the username
          return new Promise((resolve, reject) => {
               if (password === "password") {
                    setUser({name: userName, isAuthenticated: true})
                    localStorage.setItem("login", "1");
                    localStorage.setItem("login_user_name", userName);
                    setIsLoggedIn(true);
                    resolve("success")
               } else {
                    reject("Incorrect password")
               }
          })
     }

     const handleLogout = async (event) => {
     let apiUrl = API_SERVER_URL+ 'logout/'
     let method = "POST"
     try {
         const result = await apiCall(method,apiUrl);
         if(result!==undefined){
         if (result.code === API_SUCCESS_RESPONSE_CODE) {
           console.log("Logout")
         } else {
           trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
         }
         }
     } catch (error) {
       console.error("Error refreshing token:", error);
     }
     }
     
     const logout = () => {

          handleLogout()
          localStorage.clear(); 
          setIsLoggedIn(false);
          setUser({...user, isAuthenticated: false})
          navigate("/logout")
     }

     return (
               <AuthContext.Provider value={{isLoggedIn,user, login, logout}}>
                    {isLoggedIn === true ? <>
                         <RenderHeader />
                         <RenderRoutes />
                    </> : <RenderRoutes />}
               </AuthContext.Provider>
     )
}